import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { Button, DrawerBodyWrapper, DrawerFooterWrapper, MultiSelect, RadioButton, TOAST_TYPE } from '@base'
import { strings } from '@constants'
import { updateBankFacilitiesApi } from '@data/conn/put/probe'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { Label } from '../../styles'
import { ItemWrapper, RadioButtonsWrapper, RadioButtonWrapper } from '../styles'

const ChargesFacility = ({ probeId, data, update }) => {
	const dispatch = useDispatch()
	const [facilities, setFacilities] = useState([])
	const [secured, setSecured] = useState()

	useEffect(() => {
		if (data?.facilities) {
			let _data = data?.facilities?.map((item) => ({ key: item, label: item }))
			setFacilities(_data)
		}
		if (data?.is_secured) {
			setSecured(data?.is_secured)
		}
	}, [data])

	const updateState = (values) => {
		setFacilities(values)
	}

	const onSubmitHandler = () => {
		const _facilities = facilities?.map((item) => item.key)
		dispatch(showLoader(true))
		updateBankFacilitiesApi({ facilities: _facilities, probe42Id: probeId, bankName: data?.bank_name }, secured)
			.then((response) => {
				dispatch(showToast(true, 'Facilities Added successfully', { type: TOAST_TYPE.SUCCESS }))
			})
			.catch((error) => {
				dispatch(showToast(true, 'Some error occurred'), { type: TOAST_TYPE.ERROR })
			})
			.finally(() => {
				update()
				dispatch(showLoader(false))
				dispatch(toggleDrawer(false))
			})
	}

	const onRadioChange = (val) => {
		setSecured(val === 'true')
	}
	return (
		<>
			<DrawerBodyWrapper>
				<MultiSelect
					id={'facilities'}
					label={'Facilities'}
					data={[]}
					placeholder={'Enter to add new item'}
					primaryKey={'key'}
					displayKey={'label'}
					value={facilities || []}
					onChange={updateState}
					createNewOption={true}
				/>
				<ItemWrapper>
					<div>{strings('is_secured')}</div>
					<RadioButtonsWrapper>
						<RadioButtonWrapper>
							<RadioButton
								id='true-radio'
								size='1.125'
								checked={secured === true}
								value={true}
								onChange={(e) => onRadioChange(e.target.value)}
							/>
							<Label htmlFor='true-radio'>{strings('yes')}</Label>
						</RadioButtonWrapper>
						<RadioButtonWrapper>
							<RadioButton
								id='false-radio'
								size='1.125'
								checked={secured === false}
								value={false}
								onChange={(e) => onRadioChange(e.target.value)}
							/>
							<Label htmlFor='false-radio'>{strings('no')}</Label>
						</RadioButtonWrapper>
					</RadioButtonsWrapper>
				</ItemWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button small onClick={onSubmitHandler}>
					{strings('submit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default ChargesFacility
